import React, {useEffect, useState} from 'react';
import styles from "./startSection.module.sass"
import {Slider} from "./components/Slider";
import ok from "../../assets/ok_icon.png"
import tg from "../../assets/tg_icon.png"
import vk from "../../assets/vk_icon.png"
import wa from "../../assets/wa_icon.png"
import inst from "../../assets/inst_icon.png"
import plus from "../../assets/plus.png"
import line from "../../assets/Line 16.png"
import img1 from "../../assets/img_1.png"
import img2 from "../../assets/img2.png"
import img3 from "../../assets/img3.png"
import img4 from "../../assets/img4.png"
import WA from "../../assets/WA.png";
import Vk from "../../assets/VK.png";



export const StartSection = () => {

    let index: number = 0;
    const images: string[] = [img1, img2, img3, img4];
    const [imageSrc, setImageSrc] = useState<string>(images[index]);

        useEffect(() => {
            const interval = setInterval(() => {
                index = (index + 1) % images.length;
                setImageSrc(images[index]);
            }, 3000);
            return () => clearInterval(interval);
        }, []);

    const scrollToElement = (id: string) => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <div className={styles.section__start}>
            <div className={styles.background}>
                <img id='imageStart' className={styles.background__img} src={imageSrc} alt=""/>
            </div>
            <div className={styles.section__start__row1}>
                <span className={styles.section__start__header}>Ваше Величие</span>
                <div className={styles.section__start__textBlock}>
                    <span className={styles.section__start__text1} id='startPhone'>+7(987)-215-05-06</span>
                    <span onClick={() => scrollToElement('sectionOrder')} className={styles.section__start__text2}>Заказать обратный звонок</span>
                    <span onClick={() => scrollToElement('sectionOrder')} className={styles.section__start__text2}>Написать письмо</span>
                </div>
            </div>
            <div className={styles.section__start__row2}>
                <div className={styles.section__start__imgWrap}>
                    <a className={styles.section__start__imgWrap} href="https://ok.ru/vashevelichie" target='_blank'>
                        <img className={styles.section__start__img} src={ok} alt=""/>
                    </a>
                    <a className={styles.section__start__imgWrap} id='orderTg' href="https://t.me/vashe_velichie_kazan" target='_blank'>
                        <img className={styles.section__start__img} src={tg} alt=""/>
                    </a>
                    <a className={styles.section__start__imgWrap} href="https://vk.com/vashevelichie_ru" target='_blank'>
                        <img className={styles.section__start__img} src={vk} alt=""/>
                    </a>
                    <a className={styles.section__start__imgWrap} href="https://wa.me/79872548854" target='_blank'>
                        <img className={styles.section__start__img} src={wa} alt=""/>
                    </a>
                    <a className={styles.section__start__imgWrap} href="https://instagram.com/vashevelichie?igshid=MzRlODBiNWFlZA==" target='_blank'>
                        <img className={styles.section__start__img} src={inst} alt=""/>
                    </a>

                </div>
                <div className={styles.section__start__sizeWrap}>
                    <span className={styles.section__start__sizeText1}>BIG</span>
                    <span className={styles.section__start__sizeText2}>SIZE</span>
                </div>
            </div>
            <div className={styles.section__start__row3}>
                <img className={styles.section__start__smallLine} src={line} alt=""/>
                <a className={styles.section__start__text3} href='https://vk.com/market-106019478?screen=group' target='_blank'>
                    Смотреть все коллекции
                </a>
            </div>
        </div>
    );
};